import React from 'react';
import { Code, Mail, Phone, MapPin, Clock, Users } from 'lucide-react';
import { cppMockData } from './cpp-mock';

const CppFooter = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="cpp-section bg-gray-900 border-t border-gray-800">
      <div className="cpp-container">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <Code className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="cpp-heading-3 text-white">Qubit Center</div>
                <div className="text-blue-400 text-sm">Amman</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-6">
              {cppMockData.siteInfo.description}
            </p>
            <div className="text-sm text-gray-500">
              Teaching C++ programming in Amman 
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="cpp-heading-3 text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#curriculum" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Curriculum</a></li>
              <li><a href="#features" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Features</a></li>
              <li><a href="#schedule" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Schedule</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Contact</a></li>
            </ul>
          </div>
          
          {/* Course Topics */}
          <div>
            <h4 className="cpp-heading-3 text-white mb-4">What You'll Learn</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>• C++ Basics & Syntax</li>
              <li>• Variables & Data Types</li>
              <li>• Control Structures</li>
              <li>• Functions & Arrays</li>
              <li>• Problem Solving</li>
              <li>• Real Programming Projects</li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="cpp-heading-3 text-white mb-4">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-green-400" />
                <span className="text-gray-400 text-sm">{cppMockData.contact.phone}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400" />
                <span className="text-gray-400 text-sm">{cppMockData.contact.email}</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-purple-400 mt-1" />
                <span className="text-gray-400 text-sm">{cppMockData.contact.address}</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Class Schedule Footer */}
        <div className="mb-8 p-6 bg-gray-800/50 rounded-lg border border-gray-700">
          <h4 className="cpp-heading-3 text-white mb-4 text-center">📅 Current Class Schedule</h4>
          <div className="grid md:grid-cols-2 gap-6">
            {cppMockData.schedule.map((batch, index) => (
              <div key={index} className="text-center p-4 bg-gray-900/50 rounded-lg">
                <h5 className="text-blue-400 font-semibold mb-2">{batch.batch}</h5>
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Clock className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-300 text-sm">{batch.days}</span>
                </div>
                <div className="text-gray-300 text-sm mb-2">{batch.time}</div>
                <div className="flex items-center justify-center gap-2 mb-2">
                  <Users className="w-4 h-4 text-gray-400" />
                  <span className="text-gray-400 text-xs">Max 10 students</span>
                </div>
                <div className={`text-xs px-2 py-1 rounded-full inline-block ${
                  batch.status === 'Open' 
                    ? 'bg-green-500/20 text-green-400' 
                    : 'bg-orange-500/20 text-orange-400'
                }`}>
                  {batch.status}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-500 text-sm">
              © {currentYear} Qubit Center Amman. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors">
                Refund Policy
              </a>
            </div>
          </div>
          
          <div className="mt-4 text-center">
            <p className="text-gray-600 text-xs">
              🏠 Located in the heart of Amman • 📱 WhatsApp support available
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CppFooter;